/*
 * Copyright (c) 2025. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import CheckCircle from '@mui/icons-material/CheckCircle';
import RemoveCircle from '@mui/icons-material/RemoveCircle';
import RestartAlt from '@mui/icons-material/RestartAlt';
import { SvgIcon, Tooltip } from '@mui/material';
import { BidRequestInputApprovalStatus } from '@poweralpha/common';
import { getSuperAdminBadgeColor } from '../../styles';

const SuperAdminApprovalIcon = () => (
  <SvgIcon
    sx={(theme) => ({
      color: getSuperAdminBadgeColor(theme),
    })}
    viewBox="0 0 24 24"
  >
    <path d="M12 2 4 5v6c0 5.55 3.84 10.74 8 12 4.16-1.26 8-6.45 8-12V5l-8-3Z" />
    <path
      d="m8.6 12.2 2.1 2.1 4.7-4.7"
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </SvgIcon>
);

export const ApprovalIcon = ({
  approval,
  label,
  superAdminApproval = false,
}: {
  approval: BidRequestInputApprovalStatus;
  label?: string;
  superAdminApproval?: boolean;
}) => {
  const useSuperAdminIcon =
    superAdminApproval && approval === BidRequestInputApprovalStatus.APPROVED;
  let icon: React.ReactNode;
  let tooltipTitle: string | null = null;

  switch (approval) {
    case BidRequestInputApprovalStatus.APPROVED:
      icon = useSuperAdminIcon ? <SuperAdminApprovalIcon /> : <CheckCircle color="success" />;
      break;
    case BidRequestInputApprovalStatus.CHANGES_REQUESTED:
      icon = <RestartAlt color="warning" />;
      break;
    default:
      icon = <RemoveCircle color="disabled" />;
  }

  if (useSuperAdminIcon) {
    tooltipTitle = label ? `${label}: Super Admin Approval` : 'Super Admin Approval';
  } else if (label) {
    tooltipTitle = `${label}: ${approval}`;
  }

  return (
    <Tooltip title={tooltipTitle}>
      <span style={{ display: 'inline-flex' }}>{icon}</span>
    </Tooltip>
  );
};
